// extracted by mini-css-extract-plugin
export var banner = "_sd-0";
export var settingRow = "_sd-2";
export var titleIcon = "_sd-1";